// This file is auto-generated by generate-icons.js
// Do not edit manually

export const ICON_LIST: readonly string[] = [
  "404-error.svg",
  "a-b-testing.svg",
  "a-circle-icon.svg",
  "a-icon.svg",
  "access-card.svg",
  "access-code.svg",
  "access-key.svg",
  "add-event.svg",
  "add-user.svg",
  "admin.svg",
  "ai-development-1.svg",
  "ai-development-2.svg",
  "ai.svg",
  "alert-2.svg",
  "alert-3.svg",
  "alert-desktop-1.svg",
  "alert-desktop-2.svg",
  "alert-mobile.svg",
  "alert.svg",
  "algorithim.svg",
  "analysis-1.svg",
  "analysis-2.svg",
  "analysis-3.svg",
  "antivirus.svg",
  "application-development.svg",
  "arrow-bottom-right.svg",
  "arrow-down.svg",
  "arrow-left.svg",
  "arrow-right.svg",
  "arrow-top-left.svg",
  "arrow-up.svg",
  "artificial-brain.svg",
  "assistance.svg",
  "assistive-listening.svg",
  "audio-description.svg",
  "automation.svg",
  "bar-chart-1.svg",
  "bar-chart-2.svg",
  "bar-chart-3.svg",
  "bar-chart-4.svg",
  "barcode.svg",
  "blind.svg",
  "blog.svg",
  "bookmark.svg",
  "braille.svg",
  "brainstorm.svg",
  "briefcase.svg",
  "calendar.svg",
  "candidate.svg",
  "chain-link.svg",
  "chart-decrease.svg",
  "chart-growth-2.svg",
  "chat-1.svg",
  "chat-2.svg",
  "check-file-1.svg",
  "check-file-2.svg",
  "check-mobile.svg",
  "checklist.svg",
  "checkmark.svg",
  "chevron-down.svg",
  "chevron-left.svg",
  "chevron-right.svg",
  "chevron-up.svg",
  "classification.svg",
  "clipboard.svg",
  "clock.svg",
  "closed-caption.svg",
  "cloud-download.svg",
  "cloud-file-access.svg",
  "cloud-server.svg",
  "cloud-settings.svg",
  "cloud-technology-2.svg",
  "cloud-technology.svg",
  "cloud-upload.svg",
  "cloud.svg",
  "code-lock.svg",
  "coding.svg",
  "cog-wheels-1.svg",
  "cog-wheels-2.svg",
  "cog-wheels-3.svg",
  "cog-wheels-4.svg",
  "collaboration-1.svg",
  "compass.svg",
  "computer-chip.svg",
  "confirmation.svg",
  "connections.svg",
  "connectivity.svg",
  "constellation.svg",
  "contact-book.svg",
  "content-page.svg",
  "contract-1.svg",
  "contract-2.svg",
  "contract-3.svg",
  "customer-experience-1.svg",
  "customer-experience-2.svg",
  "customer-experience-3.svg",
  "customer-experience-4.svg",
  "cybersecurity.svg",
  "danger.svg",
  "data-desktop-1.svg",
  "data-desktop-2.svg",
  "data-model.svg",
  "data-protection-1.svg",
  "data-protection-2.svg",
  "data-protection-3.svg",
  "data-protection-4.svg",
  "data-safety-1.svg",
  "data-safety-2.svg",
  "data-safety-3.svg",
  "data-safety-4.svg",
  "data-structure.svg",
  "database-security.svg",
  "database.svg",
  "desk-lamp.svg",
  "desktop-settings.svg",
  "desktop.svg",
  "destination-1.svg",
  "destination-2.svg",
  "destination-3.svg",
  "destination-4.svg",
  "developer.svg",
  "devices-1.svg",
  "devices-2.svg",
  "digital-analysis.svg",
  "directions.svg",
  "discussion-1.svg",
  "discussion-2.svg",
  "discussion-3.svg",
  "discussion.svg",
  "dislike.svg",
  "double-chevron-down.svg",
  "double-chevron-left.svg",
  "double-chevron-right.svg",
  "double-chevron-up.svg",
  "earth.svg",
  "ellipsis.svg",
  "email-1.svg",
  "email-2.svg",
  "email-security.svg",
  "engineer-mind.svg",
  "eraser.svg",
  "event-canceled.svg",
  "event-confirmed.svg",
  "face-recognition-2.svg",
  "face-recognition.svg",
  "fast-forward.svg",
  "feedback-2.svg",
  "feedback.svg",
  "file-1.svg",
  "file-2.svg",
  "file-folder.svg",
  "file-security.svg",
  "filters-1.svg",
  "filters-2.svg",
  "fingerprint-security.svg",
  "flag.svg",
  "flow-chart.svg",
  "folder-1.svg",
  "folder-2.svg",
  "folder-3.svg",
  "folder-security.svg",
  "folder-settings.svg",
  "forward.svg",
  "full-screen.svg",
  "global-2.svg",
  "global-click-1.svg",
  "global-click-2.svg",
  "global-contract-2.svg",
  "global-contract.svg",
  "global-location-1.svg",
  "global-location-2.svg",
  "global-network-2.svg",
  "global-network.svg",
  "global-safety.svg",
  "global-security.svg",
  "global.svg",
  "gps-1.svg",
  "gps-2.svg",
  "group.svg",
  "guide-dog.svg",
  "hearing-aid.svg",
  "hearing-loss.svg",
  "heart.svg",
  "i-circle-icon.svg",
  "i-icon.svg",
  "idea-1.svg",
  "idea-2.svg",
  "idea-3.svg",
  "identity-card.svg",
  "increase-1.svg",
  "increase-2.svg",
  "increase-3.svg",
  "increase-4.svg",
  "information-1.svg",
  "information-2.svg",
  "internet-of-things.svg",
  "intersection.svg",
  "laptop.svg",
  "large-print.svg",
  "leader-1.svg",
  "leader-2.svg",
  "light-bulb.svg",
  "lightning-bolt.svg",
  "like.svg",
  "line-graph.svg",
  "list-1.svg",
  "list-2.svg",
  "loading-speed.svg",
  "local-network.svg",
  "location-1.svg",
  "location-2.svg",
  "lock.svg",
  "login.svg",
  "low-vision.svg",
  "mail-1.svg",
  "mail-2.svg",
  "mail-3.svg",
  "mail-confirmation.svg",
  "mail-important.svg",
  "mail-question.svg",
  "maintenance-1.svg",
  "maintenance-2.svg",
  "maintenance-3.svg",
  "man.svg",
  "map.svg",
  "marker.svg",
  "mobile-horizontal.svg",
  "mobile-settings.svg",
  "mobile.svg",
  "molecular-physics.svg",
  "navigation-1.svg",
  "navigation.svg",
  "network-2.svg",
  "network-folder.svg",
  "network-security.svg",
  "network.svg",
  "not-secure.svg",
  "notebook.svg",
  "office-1.svg",
  "office-2.svg",
  "office-chair.svg",
  "office-desk.svg",
  "online-location.svg",
  "optimization.svg",
  "organic-chemistry.svg",
  "page-loading-speed.svg",
  "page-optimization.svg",
  "paper-clip.svg",
  "password-desktop-1.svg",
  "password-desktop-2.svg",
  "password-mobile.svg",
  "pause.svg",
  "pen.svg",
  "pencil-stand.svg",
  "pencil.svg",
  "people-chat.svg",
  "people-search-1.svg",
  "people-search-2.svg",
  "people-search-3.svg",
  "personal-security-1.svg",
  "personal-security-2.svg",
  "perspective.svg",
  "physics.svg",
  "picture-1.svg",
  "picture-2.svg",
  "picture-3.svg",
  "pie-chart.svg",
  "pin.svg",
  "pinpoint.svg",
  "play.svg",
  "policies.svg",
  "presentation-1.svg",
  "presentation-2.svg",
  "presenter-1.svg",
  "presenter-2.svg",
  "privacy.svg",
  "programming-1.svg",
  "programming-2.svg",
  "question-2.svg",
  "question.svg",
  "reboot-1.svg",
  "reboot-2.svg",
  "reboot-3.svg",
  "recycle-bin.svg",
  "recycle.svg",
  "refresh.svg",
  "relationships-network-1.svg",
  "relationships-network-2.svg",
  "report-1.svg",
  "report-2.svg",
  "repsonsive-design.svg",
  "restart.svg",
  "rewind.svg",
  "robot-1.svg",
  "robot-2.svg",
  "robot-3.svg",
  "robot-4.svg",
  "robotic.svg",
  "sad.svg",
  "safety-2.svg",
  "safety.svg",
  "saved-to-cloud.svg",
  "scheduling.svg",
  "scissors.svg",
  "search-1.svg",
  "search-2.svg",
  "search-3.svg",
  "search-4.svg",
  "search-desktop-1.svg",
  "search-desktop-2.svg",
  "search-document.svg",
  "search-file.svg",
  "search-list.svg",
  "search-mobile.svg",
  "search.svg",
  "security-settings.svg",
  "security-technology.svg",
  "security.svg",
  "server.svg",
  "settings-1.svg",
  "settings.svg",
  "sever-security.svg",
  "share.svg",
  "shipping-network.svg",
  "shuffle.svg",
  "site-map.svg",
  "skip-forward.svg",
  "skip-rewind.svg",
  "smart-lock.svg",
  "smiley.svg",
  "solution-1.svg",
  "solution-2.svg",
  "speech.svg",
  "staple.svg",
  "star-of-life.svg",
  "star.svg",
  "stop-2.svg",
  "stop.svg",
  "strategy-1.svg",
  "sunglasses.svg",
  "tablet.svg",
  "target-1.svg",
  "target-2.svg",
  "team-discussion-1.svg",
  "team-discussion-2.svg",
  "team-discussion-3.svg",
  "team-discussion-4.svg",
  "team-duo.svg",
  "team-trio.svg",
  "team.svg",
  "testing-error-1.svg",
  "testing-error-2.svg",
  "testing.svg",
  "time-sheet.svg",
  "tools.svg",
  "trash-bin.svg",
  "tv-screen-1.svg",
  "tv-screen-2.svg",
  "unlock.svg",
  "user-communications.svg",
  "user-connection-1.svg",
  "user-connection-2.svg",
  "user-interface.svg",
  "user.svg",
  "virus-desktop-1.svg",
  "virus-desktop-2.svg",
  "virus.svg",
  "w-circle-icon.svg",
  "w-icon.svg",
  "warning-2.svg",
  "warning.svg",
  "waste-basket.svg",
  "web-search-1.svg",
  "web-search-2.svg",
  "webpage.svg",
  "website-design.svg",
  "website.svg",
  "wi-fi.svg",
  "wireframe-design.svg",
  "wireframe.svg",
  "wishlist.svg",
  "woman.svg",
  "working.svg",
  "zoom-in.svg",
  "zoom-out.svg"
] as const;
